module.exports = __webpack_public_path__ + "static/img/logo.7ca0d94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1